var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    transform: "matrix(-1 0 0 1 12 7.17383)",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.1085C5 16.2481 5.54085 15.4807 6.35109 15.1913V15.1913C10.004 13.8867 13.996 13.8867 17.6489 15.1913V15.1913C18.4591 15.4807 19 16.2481 19 17.1085V18.424C19 19.6114 17.9483 20.5236 16.7728 20.3557L15.8184 20.2193C13.2856 19.8575 10.7144 19.8575 8.18162 20.2193L7.22721 20.3557C6.0517 20.5236 5 19.6114 5 18.424V17.1085Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.3a7f6cf1d93cd185a80f4604efcf61c5.svg";
export { ForwardRef as ReactComponent };